// Core React
import React from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";

// Components & Views
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./views/Home";
import Login from "./views/Login";
import Invoices from "./views/Invoices";
import MealPlans from "./views/MealPlans";
import Loading from "./components/Loading";
import ErrorModal from "./components/ErrorModal";
import ListRecMealPlans from "./views/ListRecMealPlans";
import ViewRecMealPlan from "./views/ViewRecMealPlan";
import NewRecMealPlan from "./views/NewRecMealPlan";
import ErrorBoundary from "./utils/ErrorBoundary";

// CSS
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/App.css";
import "./styles/Loading.css";

// Global State
import { StateProvider, initialState, reducer } from "./utils/GlobalState";

const App = () => (
  <StateProvider initialState={initialState} reducer={reducer}>
    <ErrorBoundary>
      <Router>
        <Header />
        <ErrorModal />
        <Loading />
        <div className="container">
          <Route path="/" exact component={Home} />
          <Route path="/login" exact component={Login} />
          <Route path="/order-summary" exact component={Invoices} />
          <Route path="/mealplans" exact component={MealPlans} />
          <Route path="/recmealplans" exact component={ListRecMealPlans} />
          <Route path="/recmealplans/new" exact component={NewRecMealPlan} />
          <Route path="/recmealplan/:id" component={ViewRecMealPlan} />
        </div>
        <Footer />
      </Router>
    </ErrorBoundary>
  </StateProvider>
);

export default App;
